export default __webpack_public_path__ + "static/media/mdn.75d5d197.svg";